'use strict';

export default angular.module('fplTruescapeComApp.translateDirective', [])
  .directive('translate', function(TranslationManager, $sce, $compile) {
    TranslationManager.init();
    return {
      scope: {
        translate: '@'
      },
      restrict: 'EA',
      link: (scope, element) => {
        function _translate() {
          let html = '<span ng-bind-html="translatedText"></span>';
          let constant = scope.translate.split('.').pop();
          // Convert to uppercase constant notation
          constant = constant.toUpperCase();
          scope.translate = scope.translate.substr(0, scope.translate.lastIndexOf('.')) + '.' + constant;
          scope.translatedText = TranslationManager.getReference(scope.translate);
          html = $compile(html)(scope);
          element.replaceWith(html);
        }
        scope.$watch('translate', () => {
          if(scope.translate) {
            _translate();
          }
        });
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/translate/translate.directive.js